import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Voting System", -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column is-half" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Voting System Algorithm")
], -1)
const _hoisted_8 = { ref: "editor" }
const _hoisted_9 = { class: "content mt-4" }
const _hoisted_10 = { class: "content mt-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Utility Functions", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Prototype"),
    /*#__PURE__*/_createElementVNode("td", null, "Description")
  ])
], -1)
const _hoisted_13 = { class: "column is-half" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Preview", -1)
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Response Sheet Link", -1)
const _hoisted_17 = { class: "control" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Token Sheet", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "buttons" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Rendered Results", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_vote_result_render = _resolveComponent("vote-result-render")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            class: "input",
            type: "text",
            placeholder: "Awesome Voting System"
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, null, 512)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "button is-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
          }, "Save")
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("table", null, [
            _hoisted_12,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.utilityFunctions, (fun) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("pre", null, _toDisplayString(fun.prototype), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(fun.description), 1)
                ]))
              }), 256))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.responseSheetLink) = $event)),
              class: "input",
              type: "text",
              placeholder: "https://docs.google.com/spreadsheets/d/1xxi29IsbDvndl88EB34jx_j9yUKD-Ncpky7KvBIHn0o/edit?resourcekey#gid=1464458512"
            }, null, 512), [
              [_vModelText, _ctx.responseSheetLink]
            ])
          ])
        ]),
        _hoisted_18,
        _createElementVNode("div", null, [
          (!_ctx.tokenList)
            ? (_openBlock(), _createBlock(_component_file_upload, {
                key: 0,
                onUpload: _ctx.testFile
              }, null, 8, ["onUpload"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, " Loaded " + _toDisplayString(_ctx.tokenList.length) + " tokens ", 1))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updatePreview && _ctx.updatePreview(...args))),
            class: "button is-link"
          }, "Run Test")
        ]),
        _createElementVNode("div", null, [
          _hoisted_21,
          (_ctx.results.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.results, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: JSON.stringify(_ctx.results)
                }, [
                  _createVNode(_component_vote_result_render, { result: result }, null, 8, ["result"])
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}